
import { ymGoalCheck } from '~/helpers/ym_helper';

export default {
  name: 'AddOneClickBtn',
  data() {
    return {};
  },
  props: {
    type: {
      type: String,
      default: 'Купить в 1 клик',
    },
    pageFlag: {
      type: Boolean,
      default: false,
    },
    productPrice: {
      type: Number,
      default: null,
    },
    productName: {
      type: String,
      default: 'Быстрый заказ товара',
    },
    title: {
      type: String,
      default: 'Купить в 1 клик',
    },
    ymGoalName: {
      type: String,
      default: null,
    },
  },
  methods: {
    openBuyOneClickPopup(title) {
      ymGoalCheck({
        ymGoal: this.ymGoalName,
        ymNumber: process.env.yandexMetriks,
      });
      this.$store.commit('pop-up-buy-one-click/openBuyOneClickPopup', { title, type: this.type, ymGoalNameFromButton: this.ymGoalName });
    },
  },
};
